import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constant/constants';

/**
 * Get token from cookies
 * @param {string} tokenName - Name of the token cookie
 * @returns {string|null} - Token value or null if not found
 */
export const getToken = (tokenName) => {
  const cookieName = tokenName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (const element of cookieArray) {
    let cookie = element;
    while (cookie.startsWith(' ')) {
      cookie = cookie.substring(1);
    }
    if (cookie.startsWith(cookieName)) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null;
};

/**
 * Get access token from cookies
 * @returns {string|null} - Access token or null if not found
 */
export const getAccessToken = () => {
  return getToken(ACCESS_TOKEN);
};

/**
 * Get refresh token from cookies
 * @returns {string|null} - Refresh token or null if not found
 */
export const getRefreshToken = () => {
  return getToken(REFRESH_TOKEN);
};

/**
 * Set cookie with expiration
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Number of days until expiration
 */
export const setCookieWithExpiration = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
};

/**
 * Delete cookie
 * @param {string} name - Cookie name
 */
export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
};

/**
 * Check if user is authenticated (has both access and refresh tokens)
 * @returns {boolean} - True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();
  return !!(accessToken && refreshToken);
};

/**
 * Clear all authentication tokens
 */
export const clearAuthTokens = () => {
  deleteCookie(ACCESS_TOKEN);
  deleteCookie(REFRESH_TOKEN);
};
